import { UXFB_CLIENT_EVENTS_ENABLED_CONFIG_KEY } from './constants';

import type { IConfig } from '@cian/config/shared';

export const isUxfbClientEventsEnabled = (config: IConfig): boolean =>
  config.get<boolean>(UXFB_CLIENT_EVENTS_ENABLED_CONFIG_KEY) !== false;
